// Shared planning utilities and constants for CleanerContract forms

export const DAYS = [
  { key: 'Mon', label: 'Lundi' },
  { key: 'Tue', label: 'Mardi' },
  { key: 'Wed', label: 'Mercredi' },
  { key: 'Thu', label: 'Jeudi' },
  { key: 'Fri', label: 'Vendredi' },
  { key: 'Sat', label: 'Samedi' },
  { key: 'Sun', label: 'Dimanche' },
];

export const dayMap = DAYS.reduce((acc, d) => {
  acc[d.key] = d.label;
  return acc;
}, {});

export const orderDays = DAYS.map((d) => {
  return d.key;
});

export const serializePlanning = (planningObj) => {
  try {
    return JSON.stringify(planningObj || {});
  } catch (e) {
    return '';
  }
};

export const deserializePlanning = (serialized) => {
  if (!serialized) {
    return {};
  }
  if (typeof serialized === 'object') {
    return serialized;
  }
  try {
    const parsed = JSON.parse(serialized);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
};

// True if the (serialized) contractual planning holds at least one slot.
export const hasPlanningSlots = (serialized) => {
  const planning = deserializePlanning(serialized);
  return orderDays.some((d) => {
    return (Array.isArray(planning?.[d]) ? planning[d] : []).length > 0;
  });
};

export const timeToMinutes = (hhmm) => {
  if (!hhmm || typeof hhmm !== 'string') {
    return 0;
  }
  const [h, m] = hhmm.split(':').map(Number);
  return (Number.isFinite(h) ? h : 0) * 60 + (Number.isFinite(m) ? m : 0);
};

export const minutesBetween = (start, end) => {
  if (!start || !end) return 0;
  return Math.max(0, timeToMinutes(end) - timeToMinutes(start));
};

export const toHumanDuration = (mins) => {
  const total = Math.max(0, Number(mins) || 0);
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (m === 0) return `${h}h`;
  return `${h}h${m.toString().padStart(2, '0')}`;
};

export const hmsToMinutes = (hms) => {
  if (!hms || typeof hms !== 'string') return 0;
  const parts = hms.split(':').map((v) => {
    return Number(v) || 0;
  });
  const [h = 0, m = 0, s = 0] = parts;
  return Math.max(0, h * 60 + m + Math.floor(s / 60));
};
